export default "__VITE_ASSET__ffe11939__"